// extracted by mini-css-extract-plugin
module.exports = {"swapButtons":"swapButtons__K5ZPpCgF2tOwo","swapButton":"swapButton__KbR5qb5ejxBVU","arrow":"arrow__hSgCAe-HzRZRT"};